<!-- eslint-disable -->
<template>
	<div id="home">
		<van-swipe :autoplay="3000">
			<van-swipe-item v-for="(item, index) in images" :key="index">
				<van-cell @click="showImg()" style="padding:0">
					<img :src="item.img|addPath">
				</van-cell>
				<!-- <van-popup v-model="showPopup">
					<img :src="item.img|addPath">
				</van-popup> -->
			</van-swipe-item>
		</van-swipe>
		<div class="ind-nav ind-nav1">
			<div class="ind-tit">
				<h2>志愿世界</h2>
			</div>
		</div>
		<div style="display: flex;flex-wrap: wrap;">
			<div class="home-flex" @click="go(32,'志愿资讯')">
				<div class="home-icon">
					<img src="../../image/志愿资讯.png" class="home-img" />
					<p class="home-font">志愿资讯</p>
				</div>

			</div>
			<div class="home-flex" @click="go(21,'让爱回家')">
				<div class="home-icon">
					<img src="../../image/让爱回家.png" class="home-img" />
					<p class="home-font">让爱回家</p>
				</div>
			</div>
			<div class="home-flex" @click="go(24,'法律法规')">
				<div class="home-icon">
					<img src="../../image/法律法规.png" class="home-img" />
					<p class="home-font">法律法规</p>
				</div>
			</div>
			<div class="home-flex" @click="go(31,'通知公告')">
				<div class="home-icon">
					<img src="../../image/通知公告.png" class="home-img" />
					<p class="home-font">通知公告</p>
				</div>
			</div>
		</div>
		<div style="display: flex;flex-wrap: wrap;border-bottom: 1px solid #e0e0e0;">
			<div class="home-flex" @click="run('/serviceHour_rank')">
				<div class="home-icon">
					<img src="../../image/服务榜.png" class="home-img" />
					<p class="home-font">服务榜</p>
				</div>
			</div>
			<div class="home-flex" @click="run('/integration_rank')">
				<div class="home-icon">
					<img src="../../image/能量榜.png" class="home-img" />
					<p class="home-font">能量榜</p>
				</div>
			</div>
			<div class="home-flex" @click="go(22,'公益风采')">
				<div class="home-icon">
					<img src="../../image/公益风采.png" class="home-img" />
					<p class="home-font">公益风采</p>
				</div>
			</div>
			<div class="home-flex" @click="go(23,'公益课堂')">
				<div class="home-icon">
					<img src="../../image/公益课堂.png" class="home-img" />
					<p class="home-font">公益课堂</p>
				</div>
			</div>
		</div>

		<div class="ind-nav ind-nav1">
			<div class="ind-tit">
				<h2>加入我们</h2>
			</div>
		</div>
		<div style="display: flex;border-bottom: 1px solid #e0e0e0;">
			<div class="home-flex" @click="run('/volunteer_register')">
				<div class="home-icon">
					<img src="../../image/1.png" class="home-img" />
					<p class="home-font">志愿者注册</p>
				</div>
			</div>
			<div class="home-flex" @click="run('/organization_register')">
				<div class="home-icon">
					<img src="../../image/2.png" class="home-img" />
					<p class="home-font">组织注册</p>
				</div>
			</div>
			<div class="home-flex" @click="run('/activity_list')">
				<div class="home-icon">
					<img src="../../image/3.png" class="home-img" />
					<p class="home-font">活动招募</p>
				</div>
			</div>
			<div class="home-flex" @click="run('/organization_list')">
				<div class="home-icon">
					<img src="../../image/4.png" class="home-img" />
					<p class="home-font">加入组织</p>
				</div>
			</div>
		</div>
		<a href='http://www.beian.miit.gov.cn' style="text-align: right;"><div>桂ICP备18003585号-1</div></a>
	</div>
</template>

<script>
/* eslint-disable */
	import { Swipe, SwipeItem, Tab, Tabs, Toast, Tag, Cell, CellGroup, Popup, ImagePreview } from 'vant';
	import axios from 'axios';
	import global from '@/api/global';
	import { formatDate } from '@/js/common.js';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	Vue.use(VueCookies);
	export default {
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd');
			},
			addPath(path) {
				return global.resoursePhoto + path;
			}
		},
		components: {
			[Swipe.name]: Swipe,
			[SwipeItem.name]: SwipeItem,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs,
			[Toast.name]: Toast,
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Popup.name]: Popup
		},
		data() {
			return {
				images: [],
				showPopup :false
			}
		},
		created: function() {
			this.ajax();
		},
		methods: {
			ajax() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/loop/getphoto',
					params: {

					}
				}).then((resp) => {
					var list = resp.data.list;
					for(var i = 0; i < list.length; i++) {
						this.images.push({
							img: list[i].projectImg,
							url: list[i].htmlUrl
						});
					}
					Toast.clear();
				}).catch(() => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			run(p) {
				this.$router.push({
					path: p
				});
			},
			go(index,title) {
				this.$router.push({
					path: '/news_list',
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						'index': index,
						'title': title
					}
				});
			},
			showImg(item) {
				let array = []
				for (let i = 0; i < this.images.length; i++) {
					array.push(global.resoursePhoto + this.images[i].img)
				}
				ImagePreview(array)
			}
		}
	}
</script>

<style>
	.ind-nav {
		margin-bottom: 0.35rem;
		position: relative;
		margin: 0px;
	}
	
	.ind-nav .ind-tit {
		height: auto;
		background-color: #FFF;
	}
	
	.ind-nav .ind-tit h2 {
		font-weight: 100;
		margin: 0px;
		height: 2.85rem;
		line-height: 2.9rem;
		width: 7.2rem;
		color: #fff;
		font-size: 1.0rem;
		text-align: center;
		background: url('../../image/ind-tit.png') center center no-repeat;
		background-size: contain;
	}
	
	#home .home-font {
		text-align: center;
		margin: 0px;
		font-size: 14px;
	}
	
	#home .home-img {
		margin: 25%;
		height: auto;
		width: 50%;
		border-radius: 15%;
		margin-bottom: 0px;
		margin-top: 10%;
	}
	
	#home .home-icon {
		height: 80%;
		width: 80%;
		margin: 10%;
	}
	
	#home .home-flex {
		border: 1px solid #e0e0e0;
		border-left: 0px;
		border-bottom: 0px;
		flex: 1;
		min-width: 24.6%;
	}
	
	#home .van-swipe__indicators {
		display: none;
	}
	
	#home .van-hairline--top-bottom::after {
		border-width: 0px
	}
	
	#home .details_ {
		font-size: 14px;
		display: flex;
		margin: 10px 0px 10px 6px;
	}
	
	#home .details_span {
		overflow: hidden;
		/*超出部分隐藏*/
		white-space: nowrap;
		/*不换行*/
		text-overflow: ellipsis;
		/*超出部分文字以...显示*/
		width: 72%;
	}
	
	#home .details_time {
		overflow: hidden;
		/*超出部分隐藏*/
		white-space: nowrap;
		/*不换行*/
		text-overflow: ellipsis;
		/*超出部分文字以...显示*/
		margin-left: 10px;
		color: gray;
	}
	
	#home p {
		margin: 10px;
	}
	
	#home {
		background-color: white;
	}
	
	#home .van-tab__pane {
		height: 176px;
		background-color: white;
	}
	
	#home .van-tabs__line {
		display: none;
	}
	
	#home .van-tab--active {
		color: white;
		background-color: #1989fa;
	}
	
	#home .van-swipe-item img {
		height: 100%;
		width: 100%;
	}
	
	#home .van-swipe {
		height: 200px;
	}
</style>